module.exports = __webpack_public_path__ + "static/media/sample-pdf.a4af3e72.pdf";